import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppWanV2, ENVIRONMENT, Environment } from '@netfoundry-ui/shared/model';
import { Observable } from 'rxjs';
import { HTTP_CLIENT } from '@netfoundry-ui/shared/services';
import {
    GetOption,
    HateoasResourceOperation,
    PagedGetOption,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppWanServiceV2 extends HateoasResourceOperation<AppWanV2> {
    static defaultPaginationSize = 500;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };
    lastPageCount = 0;
    lastTotalCount = 0;

    constructor(@Inject(HTTP_CLIENT) private http: HttpClient, @Inject(ENVIRONMENT) private environment: Environment) {
        super(AppWanV2);
    }

    getResource(): Observable<AppWanV2> {
        throw new Error('Do not use: see get getAppWan');
    }

    getPage(): Observable<PagedResourceCollection<AppWanV2>> {
        throw new Error('Do not use: see getAppWans');
    }

    getAppWan(id, options: GetOption = {}): Promise<AppWanV2> {
        return super
            .getResource(id, { ...AppWanServiceV2.defaultHttpAccept, ...options })
            .toPromise()
            .then((servicePolicy) => servicePolicy);
    }

    async getAppWanPage(options?: PagedGetOption, includeProperties?: string): Promise<AppWanV2[]> {
        let params = { ...AppWanServiceV2.defaultHttpAccept, ...options };
        if (includeProperties) {
            params = { ...params, headers: { accept: `application/hal+json;includeProperties=${includeProperties}` } };
        }
        return super
            .getPage(params)
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.totalPages;
                    this.lastTotalCount = val.totalElements;
                })
            )
            .toPromise()
            .then((servicePolicies) => servicePolicies.resources);
    }

    public downloadToCsv(networkId: string): Observable<any> {
        const params = new HttpParams().set('networkId', networkId).set('size', this.lastTotalCount);
        const headers = new HttpHeaders().set('Accept', 'text/csv');
        return this.http.get(this.environment.v2apiUrl + 'app-wans', {
            headers: headers,
            params: params,
            responseType: 'text',
        });
    }

    public validateUpdate(appwanId: string, model: any) {
        const headers = new HttpHeaders().set('Accept', 'application/json').set('nf-validate', '');
        return this.http
            .patch(this.environment.v2apiUrl + 'app-wans/' + appwanId, model, {
                headers: headers,
                responseType: 'json',
            })
            .toPromise();
    }

    public async validateCreate(model: any) {
        const headers = new HttpHeaders().set('Accept', 'application/json').set('nf-validate', '');
        return this.http
            .post(this.environment.v2apiUrl + 'app-wans', model, {
                headers: headers,
                responseType: 'json',
            })
            .toPromise();
    }

    public getJson(appwanId: string): Observable<string> {
        const options: any = {};
        const url = `${this.environment.v2apiUrl}app-wans/${appwanId}/?meta=ziti,diffZiti`;
        return this.http.get(url, options) as Observable<any>;
    }

    public downloadFileFormat(
        networkId: string,
        format = 'text/csv',
        params: HttpParams = new HttpParams()
    ): Observable<any> {
        params = params.set('networkId', networkId);
        const headers = new HttpHeaders().set('Accept', format);
        return this.http.get(this.environment.v2apiUrl + 'app-wans', {
            headers: headers,
            params: params,
            responseType: 'text',
        });
    }
}
